import { MenuEntry } from '@pancakeswap-libs/uikit'
// import { useTranslation } from "react-i18next";


const config: MenuEntry[] = [
  // {
  //   label: 'Home',
  //   icon: 'HomeIcon',
  //   href: '/',
  // },
  // {
  //   label: 'Trade',
  //   icon: 'TradeIcon',
  //   initialOpenState: false,
  //   items: [
  //     {
  //       label: 'Exchange',
  //       href: '/swap',
  //     },
  //     {
  //       label: 'Liquidity',
  //       href: '/pool',
  //     }
  //   ],
  // },
  // {
  //   label: 'SERO',
  //   icon: 'NftIcon',
  //   href: 'https://sero.goer.cloud',
  // },
  {
    label: 'Exchange',
    icon: 'TradeIcon',
    href: '/swap',
  },
  {
    label: 'Liquidity',
    icon: 'PoolIcon',
    href: '/pool',
  },
  {
    label: 'Create token',
    icon: 'TicketIcon',
    href: '/createMemeToken',
  },
  {
    label: 'Create airdrop token',
    icon: 'TicketIcon',
    href: '/createToken',
  },
  // {
  //   label: 'Airdrop',
  //   icon: 'IfoIcon',
  //   href: '/airdrop',
  // },
  // {
  //   label: 'Hosting',
  //   icon: 'InfoIcon',
  //   href: '/hosting',
  // },
  {
    label: 'Create mining contract',
    icon: 'FarmIcon',
    href: '/createMemeProject',
  },
  // {
  //   label: 'Meme project list',
  //   icon: 'GroupsIcon',
  //   href: '/memelist',
  // }
  // {
  //   label: "Info",
  //   icon: "InfoIcon",
  //   href: 'https://biaswap.github.io/info/',
  // }
]

export default config
